export const GAS_N3_DECIMALS = 8;
export const GAS_NEOX_DECIMALS = 18;
